import { makeStyles } from '@mui/styles'

export const useCommentsStyles = makeStyles((theme) => ({
    container: {
        backgroundColor: theme.palette.figma.grayscale.tier7,
        fontFamily: 'acumin-pro !important',
        minWidth: '320px',
    },
    minimizedContainer: {
        backgroundColor: theme.palette.figma.grayscale.contentWrapper,
        borderRadius: theme.spacing(2),
        boxShadow: '0px 8px 16px 0px rgba(0, 0, 0, 0.17)',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(1),
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
        borderColor: theme.palette.figma.grayscale.stroke,
        marginInline: theme.spacing(2),
        marginTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    minimizedHeader: {
        marginTop: 0,
        paddingTop: theme.spacing(1.5),
        marginBottom: theme.spacing(1),
    },
    title: {
        color: theme.palette.figma.grayscale.tier1,
        marginBottom: `0 !important`,
    },
    toggleWrapper: {
        gap: theme.spacing(0.5),
        color: theme.palette.figma.grayscale.textHier1,
        marginRight: -theme.spacing(0.5),
    },
    commentList: {
        gap: theme.spacing(2),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(6),
        paddingInline: theme.spacing(2),
    },
    commentListMinimized: {
        gap: 0,
        paddingBottom: theme.spacing(4),
    },
}))
